var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-btn',{staticClass:"no-overflow-ellipsis",attrs:{"dark":"","small":"","label":"","color":_vm.chipColor},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }